module.exports = __webpack_public_path__ + "static/media/linkedin.df113f38.svg";